// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3qlhS","content":"LayoutSettings_content__2bM4Y"};